/// <amd-module name="Feed/CreateFeed/Redux/ZeroFeeds/ZeroFeedsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule";

import { IZeroFeedsState } from "./ZeroFeedsContracts";

const _zeroFeedsModule: ISagaModule<IZeroFeedsState> = {
    id: "feed-zerofeeds"
};

export const ZeroFeedsModule = [getTfsPageDataModule(), _zeroFeedsModule];
